import { useState, useEffect } from 'react';

import DenounceStatusService from "../services/DenounceStatusService";
import LogUtils from "../utils/LogUtils";

const TAG = "useDenounceStatusService";
const logUtils = new LogUtils();

export function useGetDenounceStatusForSelector(mustRefetch) {
  const [isMounted, setIsMounted] = useState(false);
  const [isLoading, setIsLoading] = useState(null);
  const [denounceStatus, setDenounceStatus] = useState([]);
  const [initialDenounceStatus, setInitialDenounceStatus] = useState(null);

  useEffect(() => {
    setIsMounted(true);

    return () => {
      setIsMounted(false);
      setDenounceStatus([]);
    };
  }, []);

  useEffect(() => {
    const denounceStatusService = new DenounceStatusService();

    async function getDenounceStatus() {
      try {
        if (!isMounted) return false;

        setIsLoading(true);
        const response = await denounceStatusService.getDenounceStatus();
        setIsLoading(false);

        if (!isMounted || !response?.data) return false;

        setDenounceStatus(getMapDenounceStatus(response.data));

      } catch (err) {
        logUtils.logErrorMsg(TAG, "Failed to getDenounceStatus", err);
        setIsLoading(false);
      }
    }

    function getMapDenounceStatus(rawData) {
      return rawData.map(status => {
        if (status.name === denounceStatusService.DENOUNCE_STATUS.OPENED.name) {
          setInitialDenounceStatus(status);
        }
        return {
          key: status?.id,
          id: status?.id,
          label: denounceStatusService.DENOUNCE_STATUS_NAME_OBJS[status.name]?.langName,
          name: status?.name
        }
      });
    }

    getDenounceStatus();

    return () => {
      setDenounceStatus([]);
      setInitialDenounceStatus(null);
    };
  }, [isMounted, mustRefetch]);

  return [isLoading, denounceStatus, initialDenounceStatus];
}
